import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
    Button,
    Select,
    DatePicker,
    Form,
    message,
    Dropdown,
    Menu,
    Popconfirm,
    Modal,
    Typography,
    Tag,
    Upload,
    Radio,
    Input,
    Col,
    Space
} from 'antd';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Icon } from '@ant-design/compatible';
import { GET_DASHBOARD_ITEMS } from '../../graphql/queries'
import { UPDATE_DASHBOARD_ITEM } from '../../graphql/mutations'
import time from '../../utils/time'
import chart from '../../utils/chart'
import moment from "moment";
import { Fileuploader } from '@ap-evolved/evolved-ui.ui.fileuploader'
import { v4 as uuidv4 } from 'uuid'
import { QueryBuilder } from '@cubejs-client/react'
import FilterGroup from '../QueryBuilder/FilterGroup'
import dashboardFilter from '../../utils/dashboardFilter'
import useQueryUpdater from './useQueryUpdater'
import DateRangeSelect from './DateRangeSelect'
import styles from './styles'
import DimFilterSelect from './DimFilterSelect'
import MenuOptions from './MenuOptions'
import PropTypes from 'prop-types'
import FilterContext from './FilterContext'

const UploadModal = ({
    showModal,
    setShowModal
}) => {

    const { afterUpload } = useContext(FilterContext)

    useEffect(() => {
        console.log(`${process.env.REACT_APP_FILEUPLOAD_API_GCP}/upload`, process.env.REACT_APP_UPLOAD_BUCKET)
    }, [])

    // useCallback
    /** 
     * @function handleProcessComplete
     * closes the upload modal and sets the update context hook to true
     */
    const handleProcessComplete = useCallback(() => {
        setTimeout(() => {
            // setShowModal(false)
            afterUpload()
        }, 500)
    })

    return (
        <Modal
            title='Upload new data ( Limit: 10MB csv or excel )'
            visible={showModal}
            onOk={() => { }}
            onCancel={() => { setShowModal(false) }}
            footer={'Note: Files larger than 10MB will fail to upload.'}
        >
            <Fileuploader
                uploadUrl={process.env.REACT_APP_FILEUPLOAD_API_GCP}
                processApi={"/upload"}
                maxFiles={1}
                bucketName={process.env.REACT_APP_UPLOAD_BUCKET}
                fieldName='file'
                acceptedFileTypes={['application/vnd.ms-excel', 'text/csv']}
                onProcessComplete={handleProcessComplete}
            />
        </Modal>
    )
}

UploadModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
}
UploadModal.defaultProps = {
    showModal: false,
    setShowModal: null
}

export default UploadModal